import {
  ChangeDetectionStrategy,
  Component,
  computed,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { ThemePipe } from '../../../../core/pipes/theme.pipe';
import { NgStyle } from '@angular/common';
import { SplicedBackgroundComponent } from '../../../spliced-background/spliced-background.component';

@Component({
  selector: 'app-practice-card',
  templateUrl: './practice-card.component.html',
  styleUrls: ['./practice-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, ThemePipe, SplicedBackgroundComponent],
})
export class PracticeCardComponent {
  @Input({ required: true }) title!: string;
  @Input({ required: true }) prize!: string;
  @Input({ required: true }) buttonLabel!: string;

  @Output() clickEvent = new EventEmitter<void>();

  private themeService = inject(ThemeService);
  private translocoService = inject(TranslocoService);
  protected readonly splicedBg = this.themeService.splicedBackgroundPlacement('practice-card');
  protected readonly splicedPlayBg =
    this.themeService.splicedBackgroundPlacement('wager-play-button');

  readonly hasPrizeShadow = computed(() => this.themeService.hasWagerCardPrizeShadow());

  readonly cardStyle: [string, string][] = [
    ['background', 'card-wager'],
    ['border', 'card-wager'],
    ['drop-shadow', 'card-wager'],
    ['border-radius', 'card-wager'],
  ];

  readonly titleStyles: [string, string][] = [
    ['type', 'card-wager-label-for-fun'],
    ['text-color', 'card-wager-label-for-fun'],
  ];

  readonly prizeShadowStyles: [string, string][] = [
    ['type', 'card-wager-label-prize'],
    ['text-shadow', 'card-wager-label-prize'],
  ];

  readonly prizeStyles: [string, string][] = [
    ['type', 'card-wager-label-prize'],
    ['text-outer-border', 'card-wager-label-prize'],
    ['text-color', 'card-wager-label-prize'],
  ];

  readonly enterStyle: [string, string][] = [
    ['type', 'card-wager-label-free-to-play'],
    ['text-color', 'card-wager-label-free-to-play'],
  ];

  readonly playButtonStyles: [string, string][] = [
    ['background-gradient', 'button-wager-primary'],
    ['border-radius', 'button-wager-primary'],
    ['height', 'button-wager-primary'],
    ['border', 'button-wager-primary'],
    ['drop-and-inner-shadow', 'button-wager-primary'],
  ];

  readonly playButtonLabelStyles: [string, string][] = [
    ['type', 'button-wager-primary-label'],
    ['text-color', 'button-wager-primary-label'],
  ];

  readonly topPadding = 'var(--card-wager-padding-top)';
  readonly bottomPadding = 'var(--card-wager-padding-bottom)';
  readonly leftPadding = 'var(--card-wager-padding-left)';
  readonly rightPadding = 'var(--card-wager-padding-right)';
  readonly playLabel = this.translocoService.translate('components.wager-options.play');

  onClick(): void {
    this.clickEvent.emit();
  }
}
